export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/prestashop.ee5c019.svg";